import { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import { api, helpers, UserContext, constants } from "../utils";
import axios from "axios";
const cancelToken = axios.CancelToken;
const source = cancelToken.source();

export default function useGetMachineSetupNames(props) {
   const userCtx = useContext(UserContext);
   const [list, setList] = useState({
      MachineSetupList: [],
      OrderRangeList: [],
      MachineSetupSuccess: false,
   });
   const orderRanges = constants.MACHINE_SETUP_ORDER_RANGE_LABELS;

   function produceDateList() {
      let days = 0;
      let lstDateRange = [];
      // let lstDateRange = [{label: "---Select---", value: -1}];
      switch (new Date().getDay()) {
         case 6:
            days = 6;
            break;
         case 0:
            days = 5;
            break;
         case 1:
            days = 4;
            break;
         case 2:
            days = 3;
            break;
         case 3:
            days = 2;
            break;
         case 4:
            days = 1;
            break;
         case 5:
            days = 0;
            break;
         default: // or whatever default value you prefer
            days = -1;
            break;
      }

      // const stDate = `${new Date().getMonth() + 1}/${new Date().getDate()}-`;
      let nextDate = new Date();
      nextDate.setDate(nextDate.getDate() + days);
      const endDate = nextDate.toLocaleDateString();
      lstDateRange.push({ label: `${orderRanges.CURRENT_WEEK} - to ${endDate}`, value: days });

      days += 7;
      nextDate = new Date();
      nextDate.setDate(nextDate.getDate() + days);
      const endDateTwoWeeks = nextDate.toLocaleDateString();
      lstDateRange.push({ label: `${orderRanges.TWO_WEEKS} - to ${endDateTwoWeeks}`, value: days });

      days += 14;
      nextDate = new Date();
      nextDate.setDate(nextDate.getDate() + days);
      const endDateFourWeeks = nextDate.toLocaleDateString();
      lstDateRange.push({ label: `${orderRanges.FOUR_WEEKS} - to ${endDateFourWeeks}`, value: days });

      if (
         userCtx?.currentUser?.isAdmin ||
         userCtx?.currentUser?.isPowerUser ||
         userCtx?.currentUser?.isProductionEdit ||
         userCtx?.currentUser?.isEngineerEdit
      ) {
         days += 14;
         nextDate = new Date();
         nextDate.setDate(nextDate.getDate() + days);
         const endDateSixWeeks = nextDate.toLocaleDateString();
         lstDateRange.push({ label: `${orderRanges.SIX_WEEKS} - to ${endDateSixWeeks}`, value: days });

         // Not applicable to Production Edit role
         if (
            userCtx?.currentUser?.isAdmin ||
            userCtx?.currentUser?.isPowerUser ||
            userCtx?.currentUser?.isEngineerEdit
         ) {
            days += 14;
            nextDate = new Date();
            nextDate.setDate(nextDate.getDate() + days);
            const endDateEightWeeks = nextDate.toLocaleDateString();
            lstDateRange.push({ label: `${orderRanges.EIGHT_WEEKS} - to ${endDateEightWeeks}`, value: days });

            days += 28;
            nextDate = new Date();
            nextDate.setDate(nextDate.getDate() + days);
            const endDateTwelveWeeks = nextDate.toLocaleDateString();
            lstDateRange.push({ label: `${orderRanges.TWELVE_WEEKS} - to ${endDateTwelveWeeks}`, value: days });
         }
      }
      return lstDateRange;
   }

   useEffect(() => {
      api
         .fetchS("MachineSetup/GetMachineSetupNameList", {}, source.token)
         .then((response) => {
            if (response.data?.success) {
               return response.data;
            } else {
               toast.error("Failed to find fetch the machine set up names");
            }
         })
         .then((data) => {
            setList({
               MachineSetupList: helpers.addLabelValueToMachineSetupDto(data.machineTypes),
               OrderRangeList: produceDateList(),
               MachineSetupSuccess: true,
            });
         })
         .catch(api.catchHandler);
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   return list;
}
